import Big from 'big.js';
import { IMarketSettings } from '@market/interfaces/IMarketSettings';

const big = Big();

export const getDiscountFeePercent = (discountIsOn: boolean, marketSettings: IMarketSettings, isSellPage = false) => {
  const BTTF_FEE_PERCENT = isSellPage ? marketSettings.sell_fee_percent : marketSettings.buy_fee_percent;
  const BFT_FEE_PERCENT = getBftFeePercent(BTTF_FEE_PERCENT, marketSettings.bft_fee_discount_percent);

  return discountIsOn ? BFT_FEE_PERCENT : BTTF_FEE_PERCENT;
};

export const getBftFeePercent = (bttfFeePercent: number, bftFeeDiscountPercent: number) => {
  const discount = Big(bttfFeePercent).times(bftFeeDiscountPercent).div(100);
  return Number(Big(bttfFeePercent).minus(discount));
};

export const getTransactionFee = (
  discountFeePercent: number,
  discountIsOn: boolean,
  totalValue: number,
  bftExchange: number
) => {
  let bfFee = big(discountFeePercent).times(totalValue).div(100);
  if (discountIsOn && bftExchange) {
    bfFee = big(bfFee).div(bftExchange);
  }

  return Number(bfFee.toFixed(4));
};

export const setToggleAutomatically = (
  bftFeePercent: number,
  discountIsOn: boolean,
  toggleTouched: boolean,
  bftExchange: number,
  totalValue: number,
  bftWalletBalance: number
): { calculatedFee?: number; calculatedDiscountIsOn: boolean; toggleBlocked: boolean } => {
  const fee = getTransactionFee(bftFeePercent, true, totalValue, bftExchange);
  const notEnoughMoney = bftWalletBalance === 0 || (big(bftWalletBalance).lt(fee));

  if (discountIsOn && notEnoughMoney) {
    return {
      toggleBlocked: notEnoughMoney,
      calculatedDiscountIsOn: false,
    };
  }

  if (
    !discountIsOn &&
    !notEnoughMoney &&
    !toggleTouched &&
    big(totalValue).gt(0)
  ) {
    return {
      calculatedFee: fee,
      calculatedDiscountIsOn: true,
      toggleBlocked: notEnoughMoney,
    };
  }

  return {
    calculatedDiscountIsOn: discountIsOn,
    toggleBlocked: notEnoughMoney,
  };
};
